// services/lessonService.js
import axiosConfig from '../../api/axiosConfig';

const lessonService = {
  // Kurs satışlarını getir (yeni)
  async getKursSatisList() {
    try {
      const response = await axiosConfig.get('/ogretmen/lessons/kurs-satis');
      return response.data.data || [];
    } catch (error) {
      console.error('Get kurs satis list error:', error);
      throw error;
    }
  },

  // Öğretmenin tüm derslerini getir
  async getAllLessons() {
    try {
      const response = await axiosConfig.get('/ogretmen/lessons');
      return response.data;
    } catch (error) {
      console.error('Get all lessons error:', error);
      throw error;
    }
  },

  // Tek ders detayını getir
  async getLessonById(id) {
    try {
      const response = await axiosConfig.get(`/ogretmen/lessons/${id}`);
      return response.data;
    } catch (error) {
      console.error('Get lesson by id error:', error);
      throw error;
    }
  },

  // Yeni ders ekle (Kurs satış bazlı)
  async createLessonWithKursSatis(lessonData) {
    try {
      const response = await axiosConfig.post('/ogretmen/lessons/with-kurs-satis', lessonData);
      return response.data;
    } catch (error) {
      console.error('Create lesson with kurs satis error:', error);
      throw error;
    }
  },

  // Yeni ders ekle
  async createLesson(lessonData) {
    try {
      console.log('=== LESSON SERVICE - CREATE LESSON ===');
      console.log('1. Gönderilen Data:', lessonData);
      console.log('2. Axios Config:', {
        baseURL: axiosConfig.defaults.baseURL,
        headers: axiosConfig.defaults.headers,
        timeout: axiosConfig.defaults.timeout
      });
      
      // URL'i açık şekilde belirtelim debug için
      const url = '/ogretmen/lessons';
      console.log('3. İstek atılacak URL:', url);
      console.log('4. Full URL tahmin:', axiosConfig.defaults.baseURL + url);
      
      const response = await axiosConfig.post(url, lessonData);
      
      console.log('5. BAŞARILI - Response:', response);
      return response.data;
    } catch (error) {
      console.error('=== LESSON SERVICE HATA ===');
      console.error('Hata Tipi:', error.name);
      console.error('Hata Mesajı:', error.message);
      console.error('Request URL:', error.config?.url);
      console.error('Request Method:', error.config?.method);
      console.error('Request Headers:', error.config?.headers);
      console.error('Request Data:', error.config?.data);
      console.error('Response Status:', error.response?.status);
      console.error('Response StatusText:', error.response?.statusText);
      console.error('Response Data:', error.response?.data);
      console.error('Full Error Object:', error);
      
      // Eğer 404 ise, alternatif URL'ler deneyelim
      if (error.response?.status === 404) {
        console.error('');
        console.error('🔴 404 HATASI - OLASI ÇÖZÜMLER:');
        console.error('1. Backend server.js dosyanızı kontrol edin');
        console.error('2. Route tanımlaması şöyle olmalı:');
        console.error("   app.use('/api/ogretmen/lessons', ogretmenderRoutes);");
        console.error('3. Ya da axiosConfig.js dosyanızda baseURL kontrol edin');
        console.error('4. Backend console\'da herhangi bir hata var mı kontrol edin');
        console.error('');
      }
      
      throw error;
    }
  },

  // Ders güncelle
  async updateLesson(id, lessonData) {
    try {
      const response = await axiosConfig.put(`/ogretmen/lessons/${id}`, lessonData);
      return response.data;
    } catch (error) {
      console.error('Update lesson error:', error);
      throw error;
    }
  },

  // Ders sil
  async deleteLesson(id) {
    try {
      const response = await axiosConfig.delete(`/ogretmen/lessons/${id}`);
      return response.data;
    } catch (error) {
      console.error('Delete lesson error:', error);
      throw error;
    }
  },

  // Öğretmenin öğrencilerini getir (dropdown için)
  async getTeacherStudents() {
    try {
      const response = await axiosConfig.get('/ogretmen/lessons/students');
      // Backend'den gelen response.data.data array'ini döndür
      return response.data.data || [];
    } catch (error) {
      console.error('Get teacher students error:', error);
      throw error;
    }
  },

  // Dersleri getir (dropdown için)
  async getAllCourses() {
    try {
      const response = await axiosConfig.get('/ogretmen/lessons/courses');
      return response.data || [];
    } catch (error) {
      console.error('Get all courses error:', error);
      throw error;
    }
  },

  // Hakediş özeti getir
  async getEarningsSummary() {
    try {
      const response = await axiosConfig.get('/ogretmen/lessons/earnings-summary');
      return response.data;
    } catch (error) {
      console.error('Get earnings summary error:', error);
      throw error;
    }
  }
};

export default lessonService;